(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const FX = window.RB.FX;

  function budgetPick(state, item, op, p, key, fallbackPrompt) {
    const st = item.vars[key] = item.vars[key] || { left: FX.amount(state, item, op.n), picked: [] };
    const cands = RB.Play.candidates(state, op.spec, item).filter(function (t) {
      if (st.picked.indexOf(t) >= 0) return false;
      const m = Core.effMight(state, t);
      if (m === null || m > st.left) return false;
      if (!st.picked.length) return true;
      const a = state.objs[st.picked[0]], b = state.objs[t];
      if (op.sameController && b.controller !== a.controller) return false;
      if (op.sameBf && !(a.loc && b.loc && Core.sameLoc(a.loc, b.loc))) return false;
      return true;
    });
    if (!cands.length) return st;
    if (FX.ask(state, item, key + "pick", {
      player: p, tag: "target", cands: cands, min: 0, max: 1,
      prompt: (op.prompt || fallbackPrompt) + " - " + st.left + " Might left (choose none to stop)",
    })) return "wait";
    const picks = FX.picksOf(item.vars[key + "pick"]);
    delete item.vars[key + "pick"];
    if (!picks.length) return st;
    st.left -= Core.effMight(state, picks[0]);
    st.picked.push(picks[0]);
    return "repeat";
  }

  function empowerObj(state, item, iid, asTarget) {
    const o = state.objs[iid];
    const cap = ((RB.Scripts.forCard(state, iid) || {}).maxEmpower) || 1;
    if (!o || (o.zone !== "board" && o.zone !== "legendZone") || (o.empowerCount || 0) >= cap) return;
    o.empowerCount = (o.empowerCount || 0) + 1;
    o.empowered = true;
    FX.opLog(state, item, "state", Core.name(state, iid) + " becomes Empowered.", asTarget ? [] : [iid], asTarget ? [iid] : []);
    FX.emit(state, { type: "empowered", iid: iid, player: o.controller });
  }

  function copyFrom(o, srcObj) {
    if (srcObj.card) { o.copyCard = srcObj.card; delete o.copyToken; }
    else if (srcObj.token) { o.copyToken = srcObj.token; delete o.copyCard; }
  }

  FX.budgetPick = budgetPick;

  Object.assign(FX.OPS, {
    deal(state, item, op, p, opp) {
      const amt = FX.amount(state, item, op.n);
      if (amt <= 0) return;
      const tgts = FX.targetsOf(state, item, op);
      if (!tgts) return;
      if (tgts.length) {
        Flow.dealDamage(state, tgts.map(function (t) {
          const b = RB.Scripts.dealBonusInfo(state, item, t);
          return { iid: t, amt: amt + b.n, base: amt, bonus: b.n, bonusFrom: b.from, by: p, src: item.label, bySpell: item.kind === "spell" };
        }));
        if (op.countByName) {
          const nm = Core.name(state, item.iid || item.source);
          state.turn.namedDamage = state.turn.namedDamage || {};
          state.turn.namedDamage[nm] = (state.turn.namedDamage[nm] || 0) + 1;
        }
      }
    },

    fight(state, item, op, p, opp) {
      const as = FX.resolveRef(state, item, op.a);
      const bs = FX.resolveRef(state, item, op.b);
      if (!as.length || !bs.length) return;
      const a = as[0], b = bs[0];
      const oa = state.objs[a], ob = state.objs[b];
      if (!oa || oa.zone !== "board" || !ob || ob.zone !== "board") return;
      const deals = [];
      const ma = Core.effMight(state, a), mb = Core.effMight(state, b);
      if (ma) deals.push({ iid: b, amt: ma, by: oa.controller, src: item.label });
      if (mb) deals.push({ iid: a, amt: mb, by: ob.controller, src: item.label });
      if (deals.length) Flow.dealDamage(state, deals);
      return;
    },

    splitDamage(state, item, op, p, opp) {
      const total = FX.amount(state, item, op.n);
      if (total <= 0) return;
      const cands = RB.Play.candidates(state, op.spec, item);
      if (!cands.length) return;
      const key = "split" + item.pc;
      item.vars[key] = item.vars[key] || { left: total, deals: {} };
      const st = item.vars[key];
      if (st.left > 0 && cands.length) {
        if (FX.ask(state, item, key + "pick", {
          player: p, tag: "target", cands: cands, min: 1, max: 1,
          prompt: (op.prompt || "Assign damage") + " - " + st.left + " left",
          split: { total: total, left: st.left, deals: Object.assign({}, st.deals) },
        })) return "wait";
        const pick = FX.picksOf(item.vars[key + "pick"])[0];
        st.deals[pick] = (st.deals[pick] || 0) + 1;
        st.left -= 1;
        delete item.vars[key + "pick"];
        return "repeat";
      }
      const deals = [];
      for (const t in st.deals) {
        const b = RB.Scripts.dealBonusInfo(state, item, t);
        deals.push({ iid: t, amt: st.deals[t] + b.n, base: st.deals[t], bonus: b.n, bonusFrom: b.from, by: p, src: item.label });
      }
      if (deals.length) Flow.dealDamage(state, deals);
      return;
    },

    amplifyDamage(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        state.fx.push({
          id: state.nextFxId++, k: "amplifyDamage", iid: t,
          times: op.times === undefined ? 2 : op.times,
          dur: op.dur || "turn", source: item.source || item.iid || null,
        });
        FX.opLog(state, item, "damage", "Damage dealt to " + Core.name(state, t) + " is multiplied by " +
          (op.times === undefined ? 2 : op.times) + " this turn.", [], [t]);
      }
      return;
    },

    kill(state, item, op, p, opp) {
      const attribution = op.credit === false
        ? { via: item.label }
        : { via: item.label, by: p, bySpell: item.kind === "spell" };
      Flow.killObjs(state, FX.refsOrSpec(state, item, op), attribution);
    },

    killBudget(state, item, op, p, opp) {
      const st = budgetPick(state, item, op, p, "kb" + item.pc, "Kill units");
      if (typeof st === "string") return st;
      if (st.picked.length) Flow.killObjs(state, st.picked, { via: item.label, by: p });
      return;
    },

    eachKills(state, item, op, p, opp) {
      const order = op.startWith === "opponent" ? [opp, p] : [p, opp];
      for (const who of order) {
        if (op.skipController && who === p) continue;
        const key = "eachKill" + who;
        if (item.vars[key] !== undefined || item.vars[key + "done"]) continue;
        const cands = Core.boardObjs(state, function (o, i2) {
          return o.controller === who && Core.isType(state, i2, "unit");
        });
        if (!cands.length) { item.vars[key] = null; continue; }
        if (cands.length === 1) {
          item.vars[key] = null;
          Flow.killObjs(state, [cands[0]], { via: item.label, by: p });
          return "repeat";
        }
        FX.ask(state, item, key, { player: who, tag: "eachKills", prompt: "Kill one of your units", cands: cands, min: 1, max: 1 });
        return "wait";
      }
      for (const who of order) {
        const key = "eachKill" + who;
        const picked = item.vars[key];
        if (Array.isArray(picked) && picked.length) {
          delete item.vars[key];
          item.vars[key + "done"] = true;
          Flow.killObjs(state, [picked[0]], { via: item.label, by: p });
          return "repeat";
        }
      }
      return;
    },

    stun(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        const o = state.objs[t];
        if (FX.replaceEffect(state, item, t, "stun")) continue;
        if (o && !o.stunned) {
          o.stunned = true;
          RB.FX.emit(state, { type: "stunned", iid: t, player: p });
        }
      }
      return;
    },

    ready(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        if (Core.readyBlocked(state, t)) {
          FX.opLog(state, item, "state", Core.name(state, t) + " cannot be readied by spells and abilities.", [], [t]);
          continue;
        }
        const o = state.objs[t];
        if (!o || o.ready) continue;
        o.ready = true;
        RB.FX.emit(state, { type: "ready", iid: t, player: p });
      }
      return;
    },

    exhaust(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) if (state.objs[t]) state.objs[t].ready = false;
      return;
    },

    heal(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) if (state.objs[t]) state.objs[t].damage = [];
      return;
    },

    buff(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        const o = state.objs[t];
        if (!o) continue;
        const sc3 = RB.Scripts.forCard(state, t);
        if (o.buffs < 1 || (sc3 && sc3.multiBuff)) {
          o.buffs += 1;
          RB.FX.emit(state, { type: "buffed", iid: t, player: p });
        }
      }
    },

    removeBuff(state, item, op, p, opp) {
      for (const t of FX.resolveRef(state, item, op.to)) {
        const o = state.objs[t];
        if (o && o.buffs > 0) o.buffs = 0;
      }
      return;
    },

    grant(state, item, op, p, opp) {
      const tgts = FX.targetsOf(state, item, op);
      if (!tgts) return;
      for (const t of tgts) {
        const o = state.objs[t];
        if (!o) continue;
        if (op.might) {
          let baseMight = typeof op.might === "number" ? op.might : FX.amount(state, item, op.might);
          if (baseMight < 0 && FX.chosenBy(item, t) && (item.kind === "spell" || item.kind === "ability")) {
            baseMight -= RB.Play.minusMightBonus(state, item.controller);
          }
          if (FX.replaceEffect(state, item, t, "minusMight") && baseMight < 0) continue;
          const mv = typeof op.might === "number"
            ? FX.flooredMight(state, t, { might: baseMight, floor: op.floor })
            : baseMight;
          o.grants.push({ k: "might", value: mv, dur: op.dur || "turn" });
        }
        if (op.setMight !== undefined) {
          const sv = typeof op.setMight === "number" ? op.setMight : FX.amount(state, item, op.setMight);
          o.grants.push({ k: "setMight", value: sv, dur: op.dur || "turn" });
        }
        if (op.keyword) o.grants.push({ k: "keyword", name: op.keyword, value: op.kwValue, dur: op.dur || "turn" });
        if (op.keywordsOf) {
          const kwSrc = FX.resolveRef(state, item, op.keywordsOf)[0];
          const kws = kwSrc ? Core.keywords(state, kwSrc) : {};
          for (const kn of Object.keys(kws).sort()) {
            o.grants.push({ k: "keyword", name: kn, value: kws[kn] === true ? null : kws[kn], dur: op.dur || "turn" });
          }
        }
        if (op.tag) o.grants.push({ k: "tag", value: op.tag, dur: op.dur || "perm" });
        if (op.buffBonus) o.grants.push({ k: "buffBonus", value: op.buffBonus, dur: op.dur || "turn" });
        if (op.untargetable) o.grants.push({ k: "untargetable", dur: op.dur || "turn" });
        if (op.noMove) {
          const nm = { k: "noMove", dur: op.dur || "turn" };
          if (op.noMoveReason) nm.reason = op.noMoveReason;
          o.grants.push(nm);
        }
      }
    },

    grantFlow(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        const o = state.objs[t];
        if (!o) continue;
        const c = Core.card(state, t);
        const cost = op.cost || { energy: (c && c.energy) || 0, pips: (c && c.power) || 0, anyPower: 0 };
        o.grants.push({ k: "flowCost", cost: cost, dur: op.dur || "turn" });
        o.grants.push({ k: "keyword", name: "flow", value: null, dur: op.dur || "turn" });
        FX.opLog(state, item, "state", Core.name(state, t) + " gains [Flow] equal to its cost this turn.", [], [t]);
      }
      return;
    },

    grantAbility(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        const o = state.objs[t];
        if (!o) continue;
        o.grants.push({ k: "ability", ability: op.ability, dur: op.dur || "turn" });
        FX.opLog(state, item, "state", Core.name(state, t) + " gains an ability this turn.", [], [t]);
      }
      return;
    },

    empower(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) empowerObj(state, item, t, true);
      return;
    },

    empowerSource(state, item, op, p, opp) {
      empowerObj(state, item, item.source || item.iid, false);
      return;
    },

    disempower(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        const o = state.objs[t];
        if (!o || !o.empowered) continue;
        o.empowerCount = Math.max(0, (o.empowerCount || 1) - 1);
        o.empowered = o.empowerCount > 0;
        FX.opLog(state, item, "state", Core.name(state, t) + " is no longer Empowered.", [], [t]);
      }
      return;
    },

    swapMight(state, item, op, p, opp) {
      const a = FX.resolveRef(state, item, op.a)[0];
      const b = FX.resolveRef(state, item, op.b)[0];
      if (!a || !b) return;
      const ma = Core.baseMight(state, a);
      const mb = Core.baseMight(state, b);
      if (ma === null || mb === null) return;
      const dur = op.dur || "turn";
      state.objs[a].grants.push({ k: "setMight", value: mb, dur: dur });
      state.objs[b].grants.push({ k: "setMight", value: ma, dur: dur });
      FX.opLog(state, item, "state", Core.name(state, a) + " and " + Core.name(state, b) + " swap Might (" + ma + " / " + mb + ").", [], [a, b]);
      return;
    },

    becomeCopy(state, item, op, p, opp) {
      const src = FX.resolveRef(state, item, op.from)[0];
      const srcObj = src && state.objs[src];
      if (!srcObj) return;
      for (const t of FX.refsOrSpec(state, item, op)) {
        const o = state.objs[t];
        if (!o || o.zone !== "board") continue;
        copyFrom(o, srcObj);
        FX.opLog(state, item, "state", Core.name(state, t) + " becomes a copy of " + Core.name(state, src) + ".", [src], [t]);
      }
      return;
    },

    copyHost(state, item, op, p, opp) {
      const hostIid = item.ctx && item.ctx.host;
      const host = hostIid && state.objs[hostIid];
      const refs = FX.resolveRef(state, item, op.from);
      if (!host || host.zone !== "board" || !refs.length) return;
      copyFrom(host, state.objs[refs[0]]);
      const gear = item.source && state.objs[item.source];
      if (gear) gear.flags.copySet = true;
      FX.opLog(state, item, "state", Core.name(state, hostIid) + " becomes a copy of " + Core.name(state, refs[0]) + ".", [hostIid, refs[0]]);
      return;
    },

    weaponEquip(state, item, op, p, opp) {
      const unit = item.source;
      const uo = unit && state.objs[unit];
      if (!uo || uo.zone !== "board") return;
      if (item.targets._wm === undefined) {
        const cands = [];
        for (const gIid in state.objs) {
          const go = state.objs[gIid];
          if (!go || go.zone !== "board" || go.controller !== p) continue;
          if (!Core.isType(state, gIid, "gear")) continue;
          const gsc = RB.Scripts.forCard(state, gIid);
          const geq = gsc && (gsc.abilities || []).find(function (ab) { return ab.label === "Equip"; });
          if (!geq) continue;

          const gcost = RB.Play.costFromRes(geq.cost, Core.card(state, gIid).domains);
          RB.Play.discountRainbow(gcost);
          if (!RB.Play.poolPotentialCovers(state, p, gcost, { gear: true })) continue;
          cands.push(gIid);
        }
        cands.sort();
        if (!cands.length) { FX.opLog(state, item, "state", item.label + ": no Equipment to attach."); return; }
        state.pending = {
          kind: "choose", player: p, tag: "target",
          prompt: "Weaponmaster: attach which Equipment?",
          src: item.label, cands: cands, min: 1, max: 1, bind: "_wm",
        };
        return "wait";
      }
      const wmPicks = item.targets._wm || [];
      if (!wmPicks.length) return;
      const gear = wmPicks[0];
      const gsc2 = RB.Scripts.forCard(state, gear);
      const eq = (gsc2.abilities || []).find(function (ab) { return ab.label === "Equip"; });
      if (!eq) return;
      const cost = RB.Play.costFromRes(eq.cost, Core.card(state, gear).domains);
      RB.Play.discountRainbow(cost);
      if (!RB.Play.costFree(cost)) {
        if (item.vars.wmPaidCancel) { FX.opLog(state, item, "state", item.label + ": Equip cost declined - nothing attached."); return; }
        if (!item.vars.wmPaid) {
          state.pending = {
            kind: "pay", player: p, cost: cost, payCtx: { gear: true },
            note: "Weaponmaster: pay the Equip cost of " + Core.name(state, gear),
            cancellable: true, varKey: "wmPaid",
          };
          return "wait";
        }
      }
      Flow.attach(state, gear, unit);
      FX.opLog(state, item, "state", Core.name(state, gear) + " equips to " + Core.name(state, unit) + " (Weaponmaster).", [gear, unit]);
      return;
    },

    attach(state, item, op, p, opp) {
      const gear = FX.resolveRef(state, item, op.to);
      const hosts = FX.resolveRef(state, item, op.host);
      if (!gear.length || !hosts.length) return;
      Flow.attach(state, gear[0], hosts[0]);
      FX.opLog(state, item, "state", Core.name(state, gear[0]) + " attaches to " + Core.name(state, hosts[0]) + ".", [gear[0], hosts[0]]);
      return;
    },

    attachFrom(state, item, op, p, opp) {
      const key = op.varKey || ("af" + item.pc);
      const hostRef = FX.resolveRef(state, item, op.from)[0];
      const dest = FX.resolveRef(state, item, op.to || "source")[0];
      if (!hostRef || !dest) return;
      const ho = state.objs[hostRef];
      const dObj = state.objs[dest];
      if (!ho || !dObj || dObj.zone !== "board") return;
      const cands = (ho.attachments || []).filter(function (a2) {
        const sc = RB.Scripts.forCard(state, a2);
        return !!(sc && (sc.abilities || []).some(function (ab) { return ab.label === "Equip"; }));
      });
      if (!cands.length) return;
      if (FX.ask(state, item, key, {
        player: p, tag: "target", cands: cands, min: op.required ? 1 : 0, max: 1,
        prompt: op.prompt || "Attach which Equipment?",
      })) return "wait";
      const picks = FX.picksOf(item.vars[key]);
      if (!picks.length) return;
      Flow.attach(state, picks[0], dest);
      FX.opLog(state, item, "state", Core.name(state, picks[0]) + " attaches to " + Core.name(state, dest) + ".", [picks[0], dest]);
      return;
    },

    attachSource(state, item, op, p, opp) {
      const tgts = FX.resolveRef(state, item, op.to);
      if (tgts.length && item.source && state.objs[item.source]) {
        Flow.attach(state, item.source, tgts[0]);
        FX.opLog(state, item, "state", Core.name(state, item.source) + " equips to " + Core.name(state, tgts[0]) + ".", [], [tgts[0]]);
      }
      return;
    },

    detach(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        const o = state.objs[t];
        if (!o || !o.attachedTo) continue;
        Flow.detach(state, t);
        FX.opLog(state, item, "state", Core.name(state, t) + " detaches.", [], [t]);
      }
      return;
    },

    detachVia(state, item, op, p, opp) {
      const via = item.ctx && item.ctx.via;
      if (via && state.objs[via] && state.objs[via].attachedTo) {
        FX.opLog(state, item, "state", Core.name(state, via) + " is unattached.", [via]);
        Flow.detach(state, via);
      }
      return;
    },

    takeControl(state, item, op, p, opp) {
      const to = op.toPlayer === "opponent" ? opp : p;
      for (const t of FX.resolveRef(state, item, op.to)) {
        const o2 = state.objs[t];
        if (!o2 || o2.zone !== "board") continue;
        o2.controller = to;
        if (op.untilSourceLeaves && item.source) o2.controlSrc = item.source;
        FX.opLog(state, item, "state", state.players[to].name + " takes control of " + Core.name(state, t) + ".", [], [t]);
        if (op.recall) Flow.recall(state, t);
      }
      state.needCleanup = true;
      return;
    },

    takeSpellControl(state, item, op, p, opp) {
      for (const t of FX.resolveRef(state, item, op.to)) {
        const target = typeof t === "string" && t.indexOf("chain:") === 0
          ? RB.Play.itemById(state, Number(t.slice(6)))
          : state.chain.find(function (it) { return it.iid === t; });
        if (!target) continue;
        target.controller = p;
        if (op.rechoose) {
          target.targets = {};
          target.status = "pending";
        }
        FX.opLog(state, item, "state", state.players[p].name + " gains control of " + target.label + ".", [target.iid].filter(Boolean));
      }
      return;
    },

    optReplaceDeath(state, item, op, p, opp) {
      const refs = op.to ? FX.resolveRef(state, item, op.to) : [];
      state.fx.push({
        id: state.nextFxId++, k: "optReplaceDeath", dur: op.dur || "turn",
        iid: refs.length ? refs[0] : null,
        controller: op.to ? undefined : p,
        requiresBuff: !!op.requiresBuff,
        unitsOnly: op.unitsOnly !== false,
        cost: op.cost || null,
        killsSource: !!op.killsSource,
        exhaustsSource: !!op.exhaustsSource,
        spendBuff: !!op.spendBuff,
        once: op.once !== false,
        source: item.source || null,
        label: op.label || item.label,
      });
      return;
    },

    deathReplaceRecall(state, item, op, p, opp) {
      for (const t of FX.resolveRef(state, item, op.to)) {
        state.fx.push({ id: state.nextFxId++, k: "recallInsteadOfDie", iid: t, dur: "turn" });
      }
      return;
    },

    deathReplaceBanish(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        state.fx.push({
          id: state.nextFxId++, k: "banishInsteadOfDie", iid: t,
          dur: op.dur || "turn", source: item.source || item.iid || null,
        });
        FX.opLog(state, item, "death", Core.name(state, t) + " will be banished instead of dying this turn.", [], [t]);
      }
      return;
    },
  });
})();
